export const getEnvironment = () => {
  switch (window.location.hostname) {
    case "labs.jasperdental.fr":
      return "production";
    case "labs.staging.jasperdental.fr":
      return "staging";
    case "localhost":
      return "local";
    default:
      return "production";
  }
};
